import { Direction } from '@angular/cdk/bidi';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { KM_SHORT, METER_SHORT, STATION_CODE, STATIONS, TRAVELING_BY_CAR } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { Coordinate } from 'src/app/modules/route-planner/interfaces/location/coordinate.interface';
import { SourceDestinationForm } from 'src/app/modules/route-planner/interfaces/route-planning/forms/source-destination-form';
import { Section } from 'src/app/modules/route-planner/interfaces/route-planning/section.interface';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';

@Component({
    selector: 'app-detailed-result-route-vehicle',
    templateUrl: './detailed-result-route-vehicle.component.html',
    styleUrl: './detailed-result-route-vehicle.component.scss',
    standalone: false
})
export class DetailedResultRouteVehicleComponent implements OnInit {
  @Input() section: Section;
  @Input() index: number;
  @Input() length: number;
  @Output() focusLocationEvent: EventEmitter<Coordinate> = new EventEmitter<Coordinate>();

  direction: Direction

  stationsText: string
  calculatedSectionDurationText: string
  stationCodeText: string
  distanceUnitShortText: string
  travelByCarText: string

  constructor(
    public readonly routePlanningService: RoutePlanningService,
    public readonly languageService: LanguageService,
  ) {

  }

  ngOnInit(): void {
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction
      this.calcSectionDuration()
      this.stationsText = STATIONS[language.language]
      this.stationCodeText = STATION_CODE[language.language]
      this.travelByCarText = TRAVELING_BY_CAR[language.language]
      this.section.travelSummary.length < 1000 ? this.distanceUnitShortText = METER_SHORT[language.language] : this.distanceUnitShortText = KM_SHORT[language.language]
    })
  }

  calcSectionDuration() {
    this.calculatedSectionDurationText = this.routePlanningService.calcSectionDuration(this.section.travelSummary.duration)
  }

  calcSectionDistance() {
    return this.routePlanningService.calcSectionDistance(this.section.travelSummary.length)
  }

}
